import type { ReactNode } from 'react';
import type { BadgeVariant } from '@/types/badge';
import styles from './Badge.module.css';

interface BadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
}

export function Badge({ variant, children }: BadgeProps) {
  return <span className={`${styles.badge} ${styles[variant]}`}>{children}</span>;
}
